import { orderBy, startCase } from 'lodash'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { CoachesCoachingKind, Note } from '@src/types'
import { formatRelativeDate } from '@src/config/momentFormat'
import { getCoachingKindDescriptor } from '@src/utils'
import { priorityOrderedCoachAssignmentsSelector } from '../../models/nutritionistHub.selectors'

export const useNotesUpdateInfo = (notes: Note[]) => {
  const allCoachAssignments = useSelector(priorityOrderedCoachAssignmentsSelector) || []

  const mntCoachAssignment = allCoachAssignments.find(
    (assignment) => assignment.coachingKind.key === CoachesCoachingKind.Mnt,
  )
  const stressCoachAssignment = allCoachAssignments.find(
    (assignment) => assignment.coachingKind.key === CoachesCoachingKind.StressManagement,
  )

  const updatedLast = useMemo(() => {
    const orderedNotes = orderBy(notes, 'updatedAt', 'desc')
    return formatRelativeDate(orderedNotes[0]?.updatedAt)
  }, [notes])

  const creator = (notes[0] as typeof notes[0] | undefined)?.creator

  if (!creator) {
    return {
      coachName: '',
      coachKind: '',
      updatedLast,
    }
  }

  let assignment
  if (creator.id === mntCoachAssignment?.coach?.id) {
    assignment = mntCoachAssignment
  } else if (creator.id === stressCoachAssignment?.coach?.id) {
    assignment = stressCoachAssignment
  } else {
    assignment = undefined
  }

  const coach = assignment?.coach
  const coachDescriptor = getCoachingKindDescriptor(assignment?.coachingKind.key)
  const firstName = coach?.firstName || ''
  const lastName = coach?.lastName || ''

  const coachName = `${startCase(firstName)} ${startCase((lastName || '').charAt(0))}`

  return {
    coachName,
    coachKind: coachDescriptor.capitalized.toString(),
    updatedLast,
  }
}
